import { cn } from "@/common/helpers/utils";
import { EmptyValue } from "@/components/ui/empty-value";
import { ReactNode } from "react";

interface DetailInfoRowProps {
  label: string;
  value?: ReactNode;
  mono?: boolean;
  fullWidth?: boolean;
  valueClassName?: string;
}

export const DetailInfoRow = ({
  label,
  value,
  mono = false,
  fullWidth = false,
  valueClassName,
}: DetailInfoRowProps) => {
  return (
    <div className={cn(fullWidth ? "sm:col-span-2" : undefined)}>
      <div className="text-muted-foreground text-xs font-medium">{label}</div>
      <div className={cn(mono ? "font-mono text-sm" : "text-sm", valueClassName)}>{value ?? <EmptyValue />}</div>
    </div>
  );
};
